module.exports = __webpack_public_path__ + "static/media/example-01.56f9f10c.jpg";